import React from 'react';

// Dentro do Estúdio a arte da campanha não fica mais em cada peça: fica na aba
// Identidade e vale pras três. No lugar do painel de arte, o editor mostra isto.
export default function AvisoIdentidade({ onIdentidade }) {
  return (
    <div className="p-2" style={{ background: '#f7f3f6', border: '1px solid #e3dae0', borderRadius: 8, fontSize: '0.78rem', color: '#5d4f58' }}>
      <div className="fw-bold mb-1" style={{ color: '#2a1f26' }}><i className="bi bi-palette me-1"></i>Arte da campanha</div>
      O logo e o fundo ficam na aba <b>Identidade</b> e valem pros stories, o pôster e o catálogo de uma vez.
      <button type="button" className="btn btn-sm btn-outline-secondary d-block mt-2" style={{ fontSize: '0.74rem' }} onClick={onIdentidade}>
        Abrir a Identidade
      </button>
    </div>
  );
}
